import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
  })
export class AppContentEn {
    public static APP_TITLE = 'Gainer Marketing';
}